export type DomainCode =
  | "GV" | "ID" | "PR" | "DE" | "RS" | "RC"
  | "OG" | "OC" | "SC" | "DS"
  | "PROFILE" | "M1" | "M2" | "M3" | "M4" | "M5" | "M6" | "M7" | "M8" | "M9" | "M10" | "RED_FLAG";

export const domainTheme: Record<DomainCode, {
  pill: string;
  solid: string;
}> = {
  GV: { pill: "bg-violet-50 text-violet-700 ring-violet-200", solid: "#7c3aed" },
  ID: { pill: "bg-indigo-50 text-indigo-700 ring-indigo-200", solid: "#4f46e5" },
  PR: { pill: "bg-emerald-50 text-emerald-700 ring-emerald-200", solid: "#059669" },
  DE: { pill: "bg-amber-50 text-amber-700 ring-amber-200", solid: "#d97706" },
  RS: { pill: "bg-rose-50 text-rose-700 ring-rose-200", solid: "#e11d48" },
  RC: { pill: "bg-sky-50 text-sky-700 ring-sky-200", solid: "#0284c7" },
  // HRV domains
  OG: { pill: "bg-teal-100 text-teal-800 ring-teal-200", solid: "#0d9488" },
  OC: { pill: "bg-blue-100 text-blue-800 ring-blue-200", solid: "#2563eb" },
  SC: { pill: "bg-amber-100 text-amber-800 ring-amber-200", solid: "#d97706" },
  DS: { pill: "bg-purple-100 text-purple-800 ring-purple-200", solid: "#7c3aed" },
  // Pre-Investment Triage modules
  PROFILE:  { pill: "bg-slate-100 text-slate-700 ring-slate-200",   solid: "#475569" },
  M1:       { pill: "bg-violet-50 text-violet-700 ring-violet-200", solid: "#7c3aed" },
  M2:       { pill: "bg-indigo-50 text-indigo-700 ring-indigo-200", solid: "#4f46e5" },
  M3:       { pill: "bg-sky-50 text-sky-700 ring-sky-200",          solid: "#0284c7" },
  M4:       { pill: "bg-cyan-50 text-cyan-700 ring-cyan-200",       solid: "#0891b2" },
  M5:       { pill: "bg-teal-50 text-teal-700 ring-teal-200",       solid: "#0d9488" },
  M6:       { pill: "bg-emerald-50 text-emerald-700 ring-emerald-200", solid: "#059669" },
  M7:       { pill: "bg-lime-50 text-lime-700 ring-lime-200",       solid: "#65a30d" },
  M8:       { pill: "bg-amber-50 text-amber-700 ring-amber-200",    solid: "#d97706" },
  M9:       { pill: "bg-orange-50 text-orange-700 ring-orange-200", solid: "#ea580c" },
  M10:      { pill: "bg-rose-50 text-rose-700 ring-rose-200",       solid: "#e11d48" },
  RED_FLAG: { pill: "bg-red-100 text-red-800 ring-red-300",         solid: "#dc2626" },
};
